export const getSfwPagePath = (page: number): string => (page === 1 ? '/sfw-images' : `/sfw-images/${page}`);

export const getSfwImagePath = (number: number): string => `/sfw-images/image/${number}`;
